var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      ref: "cargoSelect",
      staticClass: "cargo-multi-select",
      attrs: {
        multiple: "",
        "collapse-tags": "",
        disabled: _vm.disabled,
        placeholder: _vm.disabled ? "" : _vm.$t("CargoMsg.Cargo_PleaseSelect")
      },
      on: { change: _vm.onChange },
      model: {
        value: _vm.arrayVal,
        callback: function($$v) {
          _vm.arrayVal = $$v
        },
        expression: "arrayVal"
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }